export default {"src":"/_next/static/media/anything-else.6359ceb7.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};